import ManageCommunicationTemplete from "../../components/CommunicationTemplete/ManageCommunicationTemplete";

export default function CommunicationTemplete() {
  return (
    <>
    <ManageCommunicationTemplete/>
    </>
  )
}